import { Component, OnInit } from '@angular/core';
import { RouteValidationService } from "../../../../shared/route-validation.service";
import { config } from "../../../../../config/config";
import { ProgramService, BaseService } from '../../../mesc/mesc.service';
import { SystemStatusService, SystemService, ReportService, ProjectService, FunctionContactService, FunctionService } from '../../../camtl/camtl.service';
import { SystemSelectService } from '../../system-select/system-select.service';
import { BehaviorSubject } from 'rxjs';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { S3Service } from '../../../../shared/s3.service';
import { FileInfo } from '@progress/kendo-angular-upload';
import { utilities } from '../../../../../modules/utility';
import { camtlReportsUrl } from '../../../../../config/config.base';

@Component({
    selector: 'camtl-reports',
    templateUrl: './reports.component.html',
})

export class CamtlReportsComponent implements OnInit {
    constructor(
        public routerValidationService: RouteValidationService,
        public programService: ProgramService,
        public systemStatusService: SystemStatusService,
        public systemService: SystemService,
        public systemSelectService: SystemSelectService,
        public reportService: ReportService,
        public projectService: ProjectService,
        public functionContactService: FunctionContactService,
        public functionService: FunctionService,
        public baseService: BaseService,
        public cgpAlertDialogService: CgpAlertDialogService,
        private s3Service: S3Service
    ) { }

    public BASE_URL: string = camtlReportsUrl[utilities.getEnv()];

    selectedStatus: any = undefined;
    selectedSystemId: any = undefined;
    selectedProjectId: any = undefined;
    selectedProgramId: any = undefined;
    selectedMfgContactId: any = undefined;
    selectedSystemStatusId: any = undefined;

    selectedProject: any;
    selectedSystem: any;
    selectedProgram: any;
    selectedSystemStatus: any;

    public systemState: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    public programState: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

    selectedReport: any;
    reportParams: any = {
        SystemId: this.selectedSystemId,
        ProjectId: this.selectedProjectId,
        ProgramId: this.selectedProgramId,
        MfgContactId: this.selectedMfgContactId,
        SystemStatus: this.selectedSystemStatusId
    };

    allReports: any;

    ngOnInit() {
        var self = this;

        Promise.all([
            this.programService.read("", true).then(function (response) {
                self.programState.next(response);
            }),
            this.systemService.read("", true).then(function (response) {
                self.systemState.next(response);
            })
        ]).then(() => {
            this.handleSystemChange(this.selectedSystem);
        })

        this.programService
            .subscribe(data => {
                data.map(x => x.Description = x.ProgramCode + ' - ' + x.ProgramDescription);
            });

        this.projectService.query();
        this.systemStatusService.query();

        this.functionService.read()
            .then(function (response) {
                let mfgFunctionId: any;
                for (var i = 0; i < response.length; i++) {
                    if (response[i].Description == "Program Eng") { mfgFunctionId = response[i].Id; }
                }
                if (mfgFunctionId) {
                    self.functionContactService.query('/' + mfgFunctionId);
                }
            })
    }

    ngOnChanges() {
        var self = this;
        Promise.all([
            this.systemService.read("", true).then(function (response) {
                self.systemState.next(response);
            }),
            this.programService.read("", true).then(function (response) {
                self.programState.next(response);
            }),
        ]).then(() => this.handleSystemChange(this.selectedSystem))
    }


    /**
     * This method filters the dropdowns for System using the selected Program dataItem
     * @param value - Program dataItem
     */
    handleProgramChange(value: any) {
        if (value) {
            this.selectedProgram = value;
            this.selectedProgramId = value.Id;
        }

        this.setReportParams(this.selectedSystemId, this.selectedProgramId, this.selectedProjectId, this.selectedMfgContactId, this.selectedSystemStatusId);
        this.getReportsList();

        this.selectedSystem = undefined;
        this.handleSystemFilter(this.systemFilter);
    }

    /**
     * This method sets the dropdown values for Program using the selected System dataItem
    * @param value - System dataItem
    */
    handleSystemChange(value: any) {
        try {
            if (value) {
                this.selectedProgram = this.programService.value.find(x => x.Id === value.ProgramId);
                this.selectedSystemStatus = this.systemStatusService.value.find(x => x.Id === value.SystemStatusId);
                // this.selectedSystemStatus = sysStatus.Description;
                this.selectedProgramId = this.selectedProgram.Id;
                let systemId = value.Id ? value.Id : value.SystemId;
                this.selectedSystemId = systemId;
                this.selectedSystemStatusId = this.selectedSystemStatus.Id;

                this.setReportParams(this.selectedSystemId, this.selectedProgramId, this.selectedProjectId, this.selectedMfgContactId, this.selectedSystemStatusId);
                this.getReportsList();

                //if (this.selectedSystem && this.selectedSystem.Id === systemId) return;

            } else {
                this.systemFilter = undefined;
                this.selectedSystem = undefined;
                this.selectedProgram = undefined;
                this.selectedSystemStatus = undefined;
                this.handleSystemFilter();
                this.handleProgramFilter();
            }
        } catch (e) { }
    }

    handleProgramFilter = (check: string = undefined) => {
        let result: any[] = this.programService.value;
        if (check) result = result.filter(x => x.Description.toLowerCase().indexOf(check.toLowerCase()) === 0);
        if (result.length > 0) {
            this.programState.next(result);
        }
    }

    isShowSystemFilterInfo: boolean;
    systemFilter: string;

    handleSystemFilter = (check: string = undefined) => {
        this.systemFilter = check;
        let result: any[] = [];
        let systems = this.systemService.value;

        if (this.selectedProgram) {
            systems = systems.filter(x => x.ProgramId === this.selectedProgram.Id);
            result = systems;
        }

        if (check && check !== "") {
            result = systems.filter(x => {
                return x.SystemNumber.toString().toLowerCase()
                    .indexOf(check.toLowerCase()) === 0;
            });
        }

        this.isShowSystemFilterInfo = (check === undefined || check == "" || result.length == 0);

        if (result.length > 0) {
            this.systemState.next(result);
        }
    }

    onProjectSelect(value: any) {
        if (value) {
            let project = this.projectService.data;
            this.selectedProjectId = project.find((s) => s.Id === value.Id).Id;
        }
        else {
            this.selectedProjectId = undefined;
        }

        this.setReportParams(this.selectedSystemId, this.selectedProgramId, this.selectedProjectId, this.selectedMfgContactId, this.selectedSystemStatusId);
        this.getReportsList();
    }

    onMfgContactSelect(value: any) {
        if (value) {
            let mfgContacts = this.functionContactService.data;
            this.selectedMfgContactId = mfgContacts.find((s) => s.ContactId === value.ContactId).ContactId;
        }
        else {
            this.selectedMfgContactId = undefined;
        }

        this.setReportParams(this.selectedSystemId, this.selectedProgramId, this.selectedProjectId, this.selectedMfgContactId, this.selectedSystemStatusId);
        this.getReportsList();
    }

    onSystemStatusSelect(value: any) {
        if (value) {
            let systemStatus = this.systemStatusService.data;
            this.selectedSystemStatusId = systemStatus.find((s) => s.Id === value.Id).Id;
        }
        else {
            this.selectedSystemStatusId = undefined;
        }

        this.setReportParams(this.selectedSystemId, this.selectedProgramId, this.selectedProjectId, this.selectedMfgContactId, this.selectedSystemStatusId);
        this.getReportsList();
    }

    onValueChange(e) {
        this.selectedReport = e;
    }

    setReportParams(systemId, programId, projectId, mfgContactId, systemStatus) {
        this.reportParams = {
            SystemId: systemId,
            ProgramId: programId,
            ProjectId: projectId,
            MfgContactId: mfgContactId,
            SystemStatusId: systemStatus
        };
    }

    getReportsList() {
        var self = this;
        this.reportService.save(this.reportParams, true, "/getReportList", true, true, false)
            .then(function (response) {
                response = response.json();
                self.allReports = response.filter(x => x.ReportName != null);
                self.reportService.loading.next(false);
            });
    }

    s3downloadReports() {
        const report = {
            name: this.selectedReport.ReportName
        } as FileInfo;
        const _path = `CAMTLREPORTS/`;
        this.s3Service.downloadS3Object(report, _path);
    }

    // downloadReports(event) {
    //     var self = this;
    //     let report = this.selectedReport;
    //     if (report) {
    //         this.reportService.download('/download', report)
    //             .then(x => {
    //                 let blob = new Blob([(<any>x)._body], { type: 'application/pdf' });
    //                 let url = window.URL.createObjectURL(blob);
    //                 if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
    //                     navigator.msSaveOrOpenBlob(blob, report.ReportName);
    //                 }
    //                 else {
    //                     let a = document.createElement("a");
    //                     document.body.appendChild(a);
    //                     a.href = url;
    //                     a.download = report.ReportName;
    //                     a.click();
    //                     document.body.removeChild(a);
    //                     window.URL.revokeObjectURL(url);
    //                 }
    //             });
    //     }
    //     else {
    //         self.cgpAlertDialogService.showAlertDialog({
    //             title: 'Error',
    //             message: 'Please select a report to download.',
    //             alert: 'danger',
    //             closeLabel: 'Close',
    //         });
    //     }

    // }
}
